import { CostReviewAfms } from "./CostReviewAfms";
import { CostReviewAirHandlers } from "./CostReviewAirHandlers";
import { CostReviewBaseAttributes } from "./CostReviewBaseAttributes";
import { CostReviewBuildingLevelNetworkPanels } from "./CostReviewBuildingLevelNetworkPanels";
import { CostReviewChillerPlant } from "./CostReviewChillerPlant";
import { CostReviewControlValves } from "./CostReviewControlValves";
import { CostReviewDampers } from "./CostReviewDampers";
import { CostReviewExhaustFans } from "./CostReviewExhaustFans";
import { CostReviewFln } from "./CostReviewFln";
import { CostReviewHeatingPlant } from "./CostReviewHeatingPlant";
import { CostReviewHumidifiers } from "./CostReviewHumidifiers";
import { CostReviewIntegration } from "./CostReviewIntegration";
import { CostReviewLabEquipment } from "./CostReviewLabEquipment";
import { CostReviewMetering } from "./CostReviewMetering";
import { CostReviewOperatorWorkstationSoftware } from "./CostReviewOperatorWorkstationSoftware";
import { CostReviewPrefab } from "./CostReviewPrefab";
import { CostReviewSmokeDampers } from "./CostReviewSmokeDampers";
import { CostReviewTerminalControllers } from "./CostReviewTerminalControllers";
import { CostReviewVfds } from "./CostReviewVfds";
import { CostReviewWiringInterlocks } from "./CostReviewWiringInterlocks";

export class CostReviewAttributes extends CostReviewBaseAttributes {
  costReviewBuildingLevelNetworkPanels!: CostReviewBuildingLevelNetworkPanels;
  costReviewChillerPlant!: CostReviewChillerPlant;
  costReviewHeatingPlant!: CostReviewHeatingPlant;
  costReviewFln!: CostReviewFln;
  costReviewTerminalControllers!: CostReviewTerminalControllers;
  costReviewLabEquipment!: CostReviewLabEquipment;
  costReviewVfds!: CostReviewVfds;
  costReviewControlValves!: CostReviewControlValves;
  costReviewAfms!: CostReviewAfms;
  costReviewExhaustFans!: CostReviewExhaustFans;
  costReviewAirHandlers!: CostReviewAirHandlers;
  costReviewHumidifiers!: CostReviewHumidifiers;
  costReviewWiringInterlocks!: CostReviewWiringInterlocks;
  costReviewDampers!: CostReviewDampers;
  costReviewSmokeDampers!: CostReviewSmokeDampers;
  costReviewMetering!: CostReviewMetering;
  costReviewIntegration!: CostReviewIntegration;
  declare costReviewOperatorWorkstationSoftware: CostReviewOperatorWorkstationSoftware;
  visibilityOfUpdatedControls!: boolean;
  costReviewPrefab!: CostReviewPrefab;
}
